import { render, staticRenderFns } from "./bilancoformat.vue?vue&type=template&id=3510b045"
import script from "./bilancoformat.vue?vue&type=script&lang=js"
export * from "./bilancoformat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports